<div class="container freshRegister currentStep_{{step}} canDisableTooltip"
     [ngClass]="{'active' : letsGo && confStat !== 'success', 'finished' : confStat === 'success'}"
     (mouseout)="hideTooltip($event);">
  <app-tooltip-dialog *ngIf="bonusDetails && showConfirmation && bonusDetails.isCancelable" class="tooltipDialog"
                      (leaveIt)="showConfirmation = !showConfirmation"
                      (confirm)="removeBonusDetails(bonusDetails.UserIncentiveId)"></app-tooltip-dialog>
  <div class="semiTooltip onlyForDesktop" *ngIf="showSemiTooltip">{{'freshRegistration.cvvTooltip' | translate}}</div>
  <div class="register-container" [scrollTop]="registerContainerScrollTop">
    <div class="left currentStep_{{step}}">
      <div class="stepper canDisableTooltip" (mouseout)="hideTooltip($event);">
        <div class="h1">
          <h1 [ngClass]="{'active' : step != 3}">{{ 'freshRegistration.openFreeAccount' | translate }}</h1>
          <h1 [ngClass]="{'active' : step == 3}">{{ 'dashboard.addFunds.addPaymentMethod' | translate }}</h1>
        </div>
        <h2>{{ 'freshRegistration.takesAMinute' | translate }}</h2>
        <div class="steps" [ngClass]="{'withStep3':(cartItems > 0 || fakeCart)}"
             *ngIf="!showOnlyPM">
          <div (click)="goToStepForDev(1);" class="step isStep_1"
               [ngClass]="{'active' : step == 1 || step == 2 || step == 3}"></div>
          <div class="stepLine stepLine1" [ngClass]="{'active' : step == 2 || step == 3}"></div>
          <div (click)="goToStepForDev(2);" class="step isStep_2" [ngClass]="{'active' : step == 2 || step == 3}"></div>
          <div class="stepLine stepLine2" [ngClass]="{'active' : step == 3}"
               *ngIf="(cartItems > 0 || fakeCart)"></div>
          <div (click)="goToStepForDev(3);" class="step isStep_3" [ngClass]="{'active' : step == 3}"
               *ngIf="(cartItems > 0 || fakeCart)"></div>
        </div>
      </div>
      <div class="icons">
        <div class="icon">
          <div class="image"></div>
          <div class="desr notCasino">
            <span>{{ 'freshRegistration.playGlobalLotteries' | translate }}</span>
            <span>{{ 'freshRegistration.fromAnywhereInTheWorld' | translate }}</span>
          </div>
          <div class="desr casino">
            <span>{{ 'freshRegistration.depositBonus' | translate }}</span>
            <span>{{ 'freshRegistration.onYourFirstDeposit' | translate }}</span>
          </div>
        </div>
        <div class="icon">
          <div class="image"></div>
          <div class="desr notCasino">
            <span>{{ 'freshRegistration.scratchAndWin' | translate }}</span>
            <span>{{ 'freshRegistration.withScratchcards' | translate }}</span>
          </div>
          <div class="desr casino">
            <span>{{ 'freshRegistration.topCasinoGames' | translate }}</span>
            <span>{{ 'freshRegistration.slotsTableAndMore' | translate }}</span>
          </div>
        </div>
        <div class="icon">
          <div class="image"></div>
          <div class="desr notCasino">
            <span>{{ 'freshRegistration.playOnlineGames' | translate }}</span>
            <span>{{ 'freshRegistration.andInstantWin' | translate }}</span>
          </div>
          <div class="desr casino">
            <span>{{ 'freshRegistration.wordClass' | translate }}</span>
            <span>{{ 'freshRegistration.customerSupport' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="trustpilotText">
        {{ 'tp.tp2-A' | translate }} <span>{{ 'tp.tp2-B' | translate }}</span>
      </div>
      <div class="trustpilotLogo"></div>
      <div class="trustpilotStars"></div>
      <div *ngIf="!showOnlyPM" class="goBack"
           [ngClass]="{'active' : step > 1, 'hide' : confStat === 'success' || step === 3}"
           (click)="goBack();"
      >
      </div>
      <div class="closeModal" (click)="closeRegistration();" [ngClass]="{'hide' : confStat === 'success'}"></div>
    </div>
    <div class="right currentStep_{{step}}" [ngClass]="{'withBonus': bonusDetails}">
      <div class="h1">
        <h1 [ngClass]="{'active' : step == 1 && confStat !== 'success'}">{{ 'freshRegistration.openFreeAccount' | translate }}</h1>
        <h1 [ngClass]="{'active' : step == 2 && confStat !== 'success'}">{{ 'freshRegistration.yourPersonalInfo' | translate }}</h1>
        <h1 [ngClass]="{'active' : step == 3 && confStat !== 'success'}">{{ 'dashboard.addFunds.addPaymentMethod' | translate }}</h1>
      </div>
      <div *ngIf="!showOnlyPM" class="goBack"
           [ngClass]="{'active' : step > 1, 'hide' : confStat === 'success' || step === 3}"
           (click)="goBack();"
      >
      </div>
      <div class="closeModal" (click)="closeRegistration();" [ngClass]="{'hide' : confStat === 'success'}"></div>
      <div class="registration-form-background">
        <form (ngSubmit)="registerUser()"
              (keydown)="preventTrigger($event)"
              [formGroup]="registerForm"
              method="POST"
              action="/register"
        >
          <div class="stepper" *ngIf="step">
            <div class="step-container currentStep_{{step}}" (scroll)="onScroll($event);"
                 [ngClass]="{'dwSelectIsOpen' : ifDwSelectIsOpen['countryCode'] ||  ifDwSelectIsOpen['currency'], 'withBonus': bonusDetails, 'finished' : confStat === 'success'}">
              <div [ngClass]="{'active' : step == 1}" class="step step_1 currentStep_{{step}}">
                <div class="form-group">
                  <label for="registration_email">{{ 'dashboard.accountDetails.email' | translate }}</label>
                  <input [(ngModel)]="emailValueFromInput" autocomplete="email" *ngIf="email" id="registration_email"
                         type="email" name="email" placeholder="{{ 'freshRegistration.enterEmailAddress' | translate }}"
                         formControlName="email" (keydown)="auto_checkIfEmailIsAvalible();"
                         (change)="removeAllSpaces(); checkIfEmailIsAvalible(); refreshGoTo();"
                         (mouseenter)="invalidEmail($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidEmail($event));"
                         (mouseout)="removeAllSpaces(); hideTooltip($event);"
                         (focusout)="removeAllSpaces(); varInvalid['Email'] = invalidEmail();"
                         class="canDisableTooltip inputClass"
                         [ngClass]="{
                                        'error': varInvalid['Email'] || (step_1_checked && email.invalid),
                                        'success': (email.dirty || email.touched) && email.valid && emailIsAvalible === true
                                   }"/>
                  <span class="validIcon"></span>
                  <span class="errorMessage" *ngIf="step_1_checked && email.invalid">{{'ferrors.01' | translate}}</span>
                  <span class="errorMessage" *ngIf="step_1_checked && email.valid && !emailIsAvalible">{{'errors.073' | translate}}</span>
                </div>

                <div class="form-group canDisableTooltip phone-form-group" (mouseout)="hideTooltip($event);">
                  <label class="prefix">{{ 'freshRegistration.prefix' | translate }}</label>
                  <label class="mobile">{{ 'freshRegistration.mobile' | translate }}</label>
                  <div id="registration_prefix" class="phone-container pseudo-input"
                       (mouseenter)="invalidPrefix($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidPrefix($event));"
                       (change)="varInvalid['Prefix'] = invalidPrefix()"
                       [ngClass]="{'error': varInvalid['Prefix'] || (step_1_checked && prefix.invalid),
                                                    'success': prefix.valid && prefix.value.length > 0
                                               }">
                    <div *ngIf="lotteryService.isMobile" class="mobilePickPhoneExtension">
                      <span class="flag flag-{{selectedCode}}"></span>
                      <span class="selectedPrefix">{{selectedPrefix}}</span>
                      <select (change)="checkForCode($event, $event.target.value);" [disabled]="brand === 'winaija'">
                        <option *ngFor="let prefix of prefixCountries" [value]="prefix.code"
                                [selected]="selected && selected.code && (prefix.code == selected.code)">{{prefix.name}} {{prefix.dial_code}}</option>
                      </select>
                    </div>
                  </div>
                  <app-dw-select class="registration-select {{brand}}"
                                 *ngIf="!lotteryService.isMobile && prefixCountries && selected"
                                 [options]="prefixCountries"
                                 [selected]="selected"
                                 [image]="true"
                                 [search]="true"
                                 [searchFromFirstLetter]="true"
                                 [displayer]="'countryCodeDisplayName'"
                                 (change)="onSelectMethod($event)"
                                 (isOpen)="dwSelectIsOpen($event, 'countryCode');">
                  </app-dw-select>
                  <input autocomplete="tel" id="register_phone" name="phone" *ngIf="mobile" type="tel"
                         class="phone-input canDisableTooltip inputClass" required formControlName="mobile"
                         (mouseenter)="invalidMobile($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidMobile($event));"
                         (mouseout)="hideTooltip($event);"
                         (focusout)="phoneValid($event); refreshGoTo(); varInvalid['Mobile'] = invalidMobile();"
                         (input)="phoneValid($event);"
                         [ngClass]="{
                                    'error': varInvalid['Mobile'] || (step_1_checked && mobile.invalid),
                                    'success': mobile.valid && (mobile.dirty || mobile.touched) && mobile.value.length > 0
                               }"
                  />
                  <span class="validIcon"></span>
                  <span class="errorMessage" *ngIf="invalidPrefix()">{{'ferrors.17' | translate}}</span>
                  <span class="errorMessage" *ngIf="invalidMobile()">{{'ferrors.14' | translate}}</span>
                </div>
                <div class="form-group">
                  <label for="registration_password">{{ 'dashboard.accountDetails.password' | translate }}</label>
                  <span class="showPassword" (click)="showHidePwd();">
                    <span [ngClass]="{'active' : !passwordIsVisible}">{{ 'freshRegistration.showPassword' | translate }}</span>
                    <span [ngClass]="{'active' : passwordIsVisible}">{{ 'freshRegistration.hidePassword' | translate }}</span>
                  </span>
                  <input autocomplete="nope"
                         class="inputClass"
                         *ngIf="password"
                         id="registration_password"
                         type="{{passwordFieldType}}"
                         placeholder="{{ 'freshRegistration.enterPassword' | translate }}" formControlName="password"
                         (keyup)="refreshGoTo();"
                         (focusout)="varInvalid['Password'] = invalidPassword();"
                         [ngClass]="{
                                        'error': varInvalid['Password'] || (step_1_checked && password.invalid),
                                        'success': password.valid && (password.dirty || password.touched) && password.value.length > 0
                                   }"/>
                  <span class="validIcon"></span>
                  <span class="mustBe" [ngClass]="{'error' : varInvalid['Password']}">{{ 'ferrors.02' | translate }}</span>
                </div>

              </div>
              <div [ngClass]="{'active' : step == 2}" class="step step_2 currentStep_{{step}}">
                <div class="form-group halfFormGroup fullFormGroupOnMobile">
                  <label for="registration_name">{{ 'modals.fn' | translate }}</label>
                  <label for="registration_surname" class="onlyForDesktop">{{ 'modals.ln' | translate }}</label>
                  <input autocomplete="given-name"
                         *ngIf="firstName"
                         id="registration_name"
                         type="text"
                         placeholder="{{ 'freshRegistration.yourName' | translate }}"
                         formControlName="firstName" name="fname"
                         (mouseenter)="invalidFirstName($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidFirstName($event));"
                         (mouseout)="hideTooltip($event);"
                         (keyup)="refreshGoTo();"
                         (focusout)="varInvalid['FirstName'] = invalidFirstName();"
                         class="inputClass"
                         [ngClass]="{
                                        'error': varInvalid['FirstName'] || (step_2_checked && firstName.invalid),
                                        'success': firstName.valid && (firstName.dirty || firstName.touched) && firstName.value.length > 0
                                   }"/>
                  <span class="validIcon"></span>
                  <span class="errorMessage" *ngIf="invalidFirstName()">{{'ferrors.03' | translate}}</span>

                  <label for="registration_surname" class="onlyForMobile">{{ 'modals.ln' | translate }}</label>
                  <input autocomplete="family-name" *ngIf="lastName" id="registration_surname" type="text"
                         placeholder="{{ 'freshRegistration.yourSurname' | translate }}" formControlName="lastName"
                         name="lname"
                         (mouseenter)="invalidLastName($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidLastName($event));"
                         (mouseout)="hideTooltip($event);"
                         (keyup)="refreshGoTo();"
                         (focusout)="varInvalid['LastName'] = invalidLastName();"
                         class="inputClass"
                         [ngClass]="{
                                        'error': varInvalid['LastName'] || (step_2_checked && lastName.invalid),
                                        'success': lastName.valid && (lastName.dirty || lastName.touched) && lastName.value.length > 0
                                   }"
                  />
                  <span class="validIcon"></span>
                  <span class="errorMessage" *ngIf="invalidLastName()">{{'ferrors.05' | translate}}</span>

                </div>
                <div class="form-group canDisableTooltip mobileMargTop15" (mouseout)="hideTooltip($event);">
                  <label>{{ 'freshRegistration.gender' | translate }}</label>
                  <input autocomplete="nope" *ngIf="gender" type="radio" name="gender"
                         id="registration_genderSelector_male" formControlName="gender" value="Mr."
                         (change)="varInvalid['Gender'] = invalidGender();"
                  />
                  <label for="registration_genderSelector_male" class="genderSelector male"
                         id="registration_gender_male"
                         (mouseenter)="invalidGender($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidGender($event));"
                         [ngClass]="{
                                        'error': varInvalid['Gender'] || (step_2_checked && gender.invalid),
                                        'success': gender.value === 'Mr.'
                                   }"><span class="male"></span>{{ 'freshRegistration.man' | translate }}</label>
                  <input autocomplete="nope" *ngIf="gender" type="radio" name="gender"
                         id="registration_genderSelector_female" formControlName="gender" value="Ms."
                         (change)="varInvalid['Gender'] = invalidGender();"
                  />
                  <label for="registration_genderSelector_female" class="genderSelector female"
                         id="registration_gender_female"
                         (mouseenter)="invalidGender($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidGender($event));"
                         [ngClass]="{
                                        'error': varInvalid['Gender'] || (step_2_checked && gender.invalid),
                                        'success': gender.value === 'Ms.'
                                   }">
                    <span class="female"></span>
                    {{ 'freshRegistration.woman' | translate }}
                  </label>
                  <span class="errorMessage" *ngIf="invalidGender()">{{'ferrors.19' | translate}}</span>
                </div>
                <div class="form-group canDisableTooltip phone-form-group" (mouseout)="hideTooltip($event);">
                  <label>{{ 'freshRegistration.dateOfBirth' | translate }}</label>
                  <div class="onlyForMobile notForAndroid {{os}} {{browser}}">
                    <input autocomplete="nope" type="date" id="registration_birthyear" class="date {{os}} {{browser}}"
                           (change)="changeDate($event.target.value);"
                           (mouseenter)="invalidBirthYear($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidBirthYear($event));"
                           (keyup)="refreshGoTo(); varInvalid['BirthYear'] = invalidBirthYear();"
                           class="inputClass"
                           [ngClass]="{
                                        'error': varInvalid['BirthYear'] || (step_2_checked && birthYear.invalid),
                                        'success': birthYear.value && birthDateIsValid,
                                        'semiPlaceholder': birthYear.value === '' || !birthYear.value
                                        }"
                    />
                    <span class="errorMessage" *ngIf="invalidBirthYear()">{{'ferrors.07' | translate}}</span>
                  </div>
                  <div class="onlyForMobile onlyForAndroid {{os}} {{browser}}">
                    <div class="pseudo-input birthDatePseudoInput day" id="registration_birthday"
                         (mouseenter)="invalidBirthDay($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidBirthDay($event));"
                         (keyup)="varInvalid['BirthDay'] = invalidBirthDay();"
                         [ngClass]="{
                                        'error': varInvalid['BirthDay'] || (birthDay.value && birthDay.value < 1) || (birthDay.value && birthDay.value > 31) || (step_2_checked && birthDay.invalid),
                                        'success': birthDay.value && birthDateIsValid && birthDay.value >=1 && birthDay.value <= 31
                                   }">
                      <input placeholder="DD" type="number" value="{{androidDayValue}}"
                             (keyup)="validBirthInput($event.target.value, 'day');"
                             (change)="changeBirthDate($event.target.value, 'day'); validateBirthDate();"
                      />
                    </div>
                    <div class="pseudo-input birthDatePseudoInput month" id="registration_birthmonth"
                         (mouseenter)="invalidBirthMonth($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidBirthMonth($event));"
                         (keyup)="varInvalid['BirthMonth'] = invalidBirthMonth();"
                         [ngClass]="{
                                        'error': varInvalid['BirthMonth'] || (birthMonth.value && birthMonth.value < 1) || (birthMonth.value && birthMonth.value > 12) || (step_2_checked && birthMonth.invalid),
                                        'success': birthMonth.value && birthDateIsValid && birthMonth.value >= 1 && birthMonth.value <= 12
                                   }"
                    >
                      <input placeholder="MM" type="number" value="{{androidMonthValue}}"
                             (keyup)="validBirthInput($event.target.value, 'month');"
                             (change)="changeBirthDate($event.target.value, 'month'); validateBirthDate();"
                      />
                    </div>
                    <div class="pseudo-input birthDatePseudoInput year" id="registration_birthyear_2"
                         (mouseenter)="invalidBirthYear($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidBirthYear($event));"
                         (keyup)="varInvalid['BirthYear'] = invalidBirthYear();"
                         [ngClass]="{
                                        'error': varInvalid['BirthYear'] || (birthYear.value && birthYear.value < 1900) || (birthYear.value && birthYear.value > lastYear) || (step_2_checked && birthYear.invalid),
                                        'success': birthYear.value && birthDateIsValid && birthYear.value >= 1900 && birthYear.value <= lastYear
                                   }">
                      <input placeholder="YYYY" type="number" value="{{androidYearValue}}"
                             (keyup)="validBirthInput($event.target.value, 'year');"
                             (change)="changeBirthDate($event.target.value, 'year'); validateBirthDate();"
                      />
                    </div>
                  </div>
                  <div class="pseudo-input birthDatePseudoInput day onlyForDesktop" id="registration_birthday_2"
                       (mouseenter)="invalidBirthDay($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidBirthDay($event));"
                       [ngClass]="{
                                        'error': varInvalid['BirthDay'] || (step_2_checked && birthDay.invalid),
                                        'success': birthDay.value && birthDateIsValid
                                   }">
                    <app-dw-select class="registration-select fittedOne"
                                   *ngIf="birthDay && showBirthDate && !lotteryService.isMobile"
                                   [options]="dayValuesForDw"
                                   [selected]="1"
                                   [image]="false"
                                   [search]="false"
                                   [searchFromFirstLetter]="false"
                                   [displayer]="'birthdayDisplayName'"
                                   (change)="changeBirthDate($event.selectValue, 'day'); varInvalid['BirthDay'] = invalidBirthDay();">
                    </app-dw-select>
                  </div>
                  <div class="pseudo-input birthDatePseudoInput month onlyForDesktop" id="registration_birthmonth_2"
                       (mouseenter)="invalidBirthMonth($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidBirthMonth($event));"
                       [ngClass]="{
                                        'error': varInvalid['BirthMonth'] || (step_2_checked && birthMonth.invalid),
                                        'success': birthMonth.value && birthDateIsValid
                                   }">
                    <app-dw-select class="registration-select fittedOne"
                                   *ngIf="birthMonth && showBirthDate && !lotteryService.isMobile"
                                   [options]="monthValuesForDw"
                                   [selected]="1"
                                   [image]="false"
                                   [search]="false"
                                   [searchFromFirstLetter]="false"
                                   [displayer]="'birthmonthDisplayName'"
                                   (change)="changeBirthDate($event.selectValue, 'month'); varInvalid['BirthMonth'] = invalidBirthMonth();">
                    </app-dw-select>
                  </div>
                  <div class="pseudo-input birthDatePseudoInput year onlyForDesktop" id="registration_birthyear_3"
                       (mouseenter)="invalidBirthYear($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidBirthYear($event));"
                       [ngClass]="{
                                        'error': varInvalid['BirthYear'] || (step_2_checked && birthYear.invalid),
                                        'success': birthYear.value && birthDateIsValid
                                   }">
                    <app-dw-select class="registration-select fittedOne"
                                   *ngIf="birthYear && showBirthDate && !lotteryService.isMobile"
                                   [options]="yearValuesForDw"
                                   [selected]="defaultYear"
                                   [image]="false"
                                   [search]="false"
                                   [searchFromFirstLetter]="false"
                                   [displayer]="'birthyearDisplayName'"
                                   (change)="changeBirthDate($event.selectValue, 'year'); varInvalid['BirthYear'] = invalidBirthYear();">
                    </app-dw-select>
                  </div>
                </div>
                <div class="form-group">
                  <label for="registration_address">{{ 'modals.address' | translate }}</label>
                  <input autocomplete="street-address" *ngIf="address" id="registration_address" type="text"
                         placeholder="{{ 'freshRegistration.streetAndHouseNumber' | translate }}"
                         formControlName="address" name="address"
                         (mouseenter)="invalidAddress($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidAddress($event));"
                         (mouseout)="hideTooltip($event);"
                         (keyup)="refreshGoTo();"
                         (focusout)="varInvalid['Address'] = invalidAddress();"
                         class="canDisableTooltip inputClass"
                         [ngClass]="{
                                        'error': varInvalid['Address'] || (step_2_checked && address.invalid),
                                        'success': address.valid && (address.dirty || address.touched) && address.value.length > 0
                                   }"/>
                  <span class="validIcon"></span>
                  <span class="errorMessage" *ngIf="invalidAddress()">{{'ferrors.20' | translate}}</span>
                </div>
                <div class="form-group halfFormGroup">
                  <label for="registration_city">{{ 'modals.city' | translate }}</label>
                  <label for="registration_postcode">{{ 'modals.postcode' | translate }}</label>
                  <input autocomplete="address-level2" *ngIf="city" id="registration_city" type="text"
                         formControlName="city" name="city"
                         (mouseenter)="invalidCity($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidCity($event));"
                         (mouseout)="hideTooltip($event);"
                         (keyup)="refreshGoTo();"
                         (focusout)="varInvalid['City'] = invalidCity();"
                         class="canDisableTooltip inputClass"
                         [ngClass]="{
                                        'error': varInvalid['City'] || (step_2_checked && city.invalid),
                                        'success': city.valid && (city.dirty || city.touched) && city.value.length > 0
                                   }"
                  />
                  <span class="validIcon"></span>
                  <input autocomplete="postal-code" *ngIf="postcode" id="registration_postcode" type="text"
                         formControlName="postcode" name="postal"
                         (mouseenter)="invalidPostcode($event); activeTooltip = true; showTooltip($event, tooltipMessage, invalidPostcode($event));"
                         (mouseout)="hideTooltip($event);"
                         (keyup)="refreshGoTo();"
                         (focusout)="varInvalid['Postcode'] = invalidPostcode();"
                         class="canDisableTooltip inputClass"
                         [ngClass]="{
                                        'error': varInvalid['Postcode'] || (step_2_checked && postcode.invalid),
                                        'success': postcode.valid && (postcode.dirty || postcode.touched) && postcode.value.length > 0
                                   }"
                  />
                  <span class="validIcon"></span>
                  <span class="errorMessage" *ngIf="invalidCity()">{{'ferrors.11' | translate}}</span>
                  <span class="errorMessage" *ngIf="invalidPostcode()">{{'ferrors.18' | translate}}</span>
                </div>
                <div class="form-group">
                  <label for="currency">{{ 'multicurrency.currency' | translate }}</label>
                  <div class="pseudo-input multiCurrencyPseudoInput success" id="currency" *ngIf="allCurrencies">
                    <app-dw-select
                      class="fittedOne registration-select {{brand}}"
                      [options]="allCurrencies"
                      [selected]="defaultCurrency"
                      [image]="false"
                      [search]="false"
                      [searchFromFirstLetter]="false"
                      [displayer]="'currencyDisplayName'"
                      (change)="refreshGoTo(); changeCurrency($event.Code);"
                      (isOpen)="dwSelectIsOpen($event, 'currency');"></app-dw-select>
                  </div>
                </div>
              </div>
              <div [ngClass]="{'active' : step == 3, 'withBonus': bonusDetails}"
                   class="step step_3 currentStep_{{step}}">
                <div class="bonusIncentive" *ngIf="bonusDetails">
                  <span class="close" *ngIf="bonusDetails.isCancelable"
                        (click)="askForRmoveBonusDetails(bonusDetails.UserIncentiveId);"></span>
                  <span class="header">{{ 'freshRegistration.welcomeBonus' | translate }}</span>
                  <span class="content">{{ 'freshRegistration.yeeHaw' | translate }}</span>
                </div>
                <div class="carousel-group" *ngIf="gapo">
                  <!--                                    <div class="navigation navigationFor_{{gapo.length}} navigationIs_{{higherThan(gapo.length, 3)}} left" (click)="movePMs('left');"></div>-->
                  <div class="paymentMethods gridFor_{{gapo.length}} paymentMethods_{{higherThan(gapo.length, 3)}}"
                       #paymentMethods (mouseenter)="this.dragAndDrop()" (mousedown)="hold = true;"
                       (mouseup)="hold = false;" (mouseleave)="hold = false;"
                  >
                    <div class="paymentGrid gridFor_{{gapo.length}}" #paymentGrid>
                      <div
                              class="paymentMethod methods_{{gapo.length}} method_{{pm.paymentMethod}} currentPM_{{currentPM}} smallerTabs_{{higherThan(gapo.length, 3)}}"
                              [ngClass]="{'active' : currentPM === pm.paymentMethod}"
                              *ngFor="let pm of gapo;let i = index"
                              (click)="clearFields(); currentPM = pm.paymentMethod; currentPMname = pm.paymentMethodDisplayName; validateForOnlyAddPm(); validatePmsForOnly3Step();"
                      >
                        <div class="icon">
                          <div class="image LANG{{subscriptionsService.countryCodeValue}} {{pm.paymentMethod}} iconsFor_{{gapo.length}}"></div>
                        </div>
                        <span *ngIf="pm.paymentMethod !== 'Card' && pm.paymentMethod !== 'apmgw_Interac_eTransfer'">{{pm.paymentMethodDisplayName}}</span>
                        <span *ngIf="pm.paymentMethod === 'Card' && this.subscriptionsService.countryCodeValue !== 'de'">Visa/Mastercard</span>
                        <span *ngIf="pm.paymentMethod === 'Card' && this.subscriptionsService.countryCodeValue === 'de'">Mastercard</span>
                        <span *ngIf="pm.paymentMethod === 'apmgw_Interac_eTransfer'">Interac®<br>e-Transfer</span>
                      </div>
                    </div>
                  </div>
                  <!--                                    <div class="navigation navigationFor_{{gapo.length}} navigationIs_{{higherThan(gapo.length, 3)}} right" (click)="movePMs('right');"></div>-->
                </div>
                <div class="semiStep semiStep_1" [ngClass]="{'active' : currentPM === 'Card', 'withBonus': bonusDetails}">
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'Card'}">
                    <label for="registration_card_number">{{ 'dashboard.addFundsDeposit.f3' | translate }}</label>
                    <input autocomplete="cc-number"
                           id="registration_card_number"
                           type="text"
                           inputmode="numeric"
                           placeholder="1234 1234 1234 1234"
                           formControlName="cardNumber"
                           name="cardnumber"
                           pattern="\d*"
                           mask="0000 0000 0000 0000"
                           (keyup)="checkType(); validatePmsForOnly3Step(); varInvalid['CardNumber'] = invalidCardNumber();"
                           class="{{cardType}} inputClass"
                           [ngClass]="{
                                            'error': varInvalid['CardNumber'] ,
                                            'success': cardNumber.valid && (cardNumber.dirty || cardNumber.touched) && cardNumber.value.length > 0
                                       }" />
                    <span class="validIcon"></span>
                  </div>
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'Card'}">
                    <label for="registration_name_on_card">{{ 'dashboard.addFundsDeposit.f1' | translate }}</label>
                    <input autocomplete="cc-name" id="registration_name_on_card" type="text" placeholder="{{ 'dashboard.addFundsDeposit.f1' | translate }}" formControlName="nameOnCard" name="ccname"
                           (keyup)="validatePmsForOnly3Step(); varInvalid['NameOnCard'] = invalidNameOnCard();"
                           class="inputClass"
                           [ngClass]="{
                                            'error': varInvalid['NameOnCard'],
                                            'success': nameOnCard.valid && nameOnCard.value.length > 0
                                       }" />
                    <span class="validIcon"></span>
                  </div>
                  <div class="form-group halfFormGroup" [ngClass]="{'disabled' : currentPM != 'Card'}">
                    <label for="registration_expiry_date">{{ 'dashboard.addFundsDeposit.f4' | translate }}</label>
                    <label for="registration_security_code">{{ 'freshRegistration.securityCode' | translate }}</label>
                    <input autocomplete="cc-exp"
                           id="registration_expiry_date"
                           type="text"
                           placeholder="MM / YY"
                           formControlName="expiryDate"
                           maxlength="5" name="cc-exp"
                           [dropSpecialCharacters]="false"
                           mask="00/00"
                           inputmode="numeric"
                           (mouseenter)="showTooltip($event, tooltipMessage, invalidExpiryDate());"
                           (mouseout)="hideTooltip($event);"
                           class="canDisableTooltip inputClass"
                           (keyup)="validatePmsForOnly3Step(); varInvalid['ExpiryDate'] = invalidExpiryDate();"
                           [ngClass]="{
                                            'error': varInvalid['ExpiryDate'],
                                            'success': expiryDate.valid && (expiryDate.dirty || expiryDate.touched) && expiryDate.value.length > 0
                                           }"/>
                    <span class="validIcon"></span>
                    <input autocomplete="cc-csc" id="registration_security_code"
                           type="text"

                           pattern="\d*"
                           inputmode="numeric"
                           placeholder="{{ 'freshRegistration.cvv' | translate }}" formControlName="securityCode" name="cvc"
                           (mouseenter)="showTooltip($event, tooltipMessage, invalidSecurityCode());"
                           (mouseout)="hideTooltip($event);"
                           (keyup)="validatePmsForOnly3Step(); varInvalid['SecurityCode'] = invalidSecurityCode();"
                           class="canDisableTooltip inputClass"
                           [ngClass]="{
                                            'error': varInvalid['SecurityCode'] ,
                                            'success': securityCode.valid && (securityCode.dirty || securityCode.touched) && securityCode.value.toString().length > 0
                                            }"/>
                    <span class="validIcon"></span>
                    <div class="semiTooltipQuestionMark" (mouseenter)="showSemiTooltip=true;" (click)="showSemiTooltip=true;" (mouseleave)="showSemiTooltip=false;"></div>
                    <div class="semiTooltip onlyForMobile" *ngIf="showSemiTooltip">{{'freshRegistration.cvvTooltip' | translate}}</div>
                  </div>
                </div>
                <div class="semiStep semiStep_2" [ngClass]="{'active' : currentPM === 'apmgw_Neteller', 'withBonus': bonusDetails}">
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Neteller'}">
                    <label for="registration_NettelerAccount">Account ID</label>
                    <input autocomplete="nope" id="registration_NettelerAccount" type="text" placeholder="Account ID" formControlName="NettelerAccount"
                           (keyup)="validatePmsForOnly3Step(); varInvalid['NettelerAccount'] = invalidNettelerAccount();"
                           class="inputClass"
                           [ngClass]="{
                                            'error': varInvalid['NettelerAccount'],
                                            'success': NettelerAccount.valid && (NettelerAccount.dirty || NettelerAccount.touched) && NettelerAccount.value.length > 0
                                       }" />
                  </div>
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Neteller'}">
                    <label for="registration_NettelerSecureId">Secure ID or Authentication code</label>
                    <input autocomplete="nope" id="registration_NettelerSecureId" type="text" placeholder="Secure ID or Authentication code" formControlName="NettelerSecureId"
                           (keyup)="validatePmsForOnly3Step(); varInvalid['NettelerSecureId'] = invalidNettelerSecureId();"
                           class="inputClass"
                           [ngClass]="{
                                            'error': varInvalid['NettelerSecureId'],
                                            'success': NettelerSecureId.valid && (NettelerSecureId.dirty || NettelerSecureId.touched) && NettelerSecureId.value.length > 0
                                       }" />
                  </div>
                </div>
                <div class="semiStep semiStep_3" [ngClass]="{'active' : currentPM === 'apmgw_EnterCash', 'withBonus': bonusDetails}">
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_EnterCash'}">
                    <label for="registration_EnterCashEmail">Player Email</label>
                    <input autocomplete="nope" id="registration_EnterCashEmail" type="text" placeholder="Player Email" formControlName="EnterCashEmail"
                           (keyup)="validatePmsForOnly3Step(); varInvalid['EnterCashEmail'] = invalidEnterCashEmail();"
                           class="inputClass"
                           [ngClass]="{
                                            'error': varInvalid['EnterCashEmail'],
                                            'success': EnterCashEmail.valid && (EnterCashEmail.dirty || EnterCashEmail.touched) && EnterCashEmail.value.length > 0
                                       }" />
                  </div>
                </div>
                <div class="semiStep semiStep_4" [ngClass]="{'active' : currentPM === 'apmgw_Sofort', 'withBonus': bonusDetails}">
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Sofort'}">
                    <h2>{{ 'freshRegistration.apm.sofort.title' | translate | replace:'\\[pm-name\\]':currentPMname }}</h2>
                  </div>
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Sofort'}">
                    <p>{{ 'freshRegistration.apm.sofort.message' | translate | replace:'\\[pm-name\\]':currentPMname }}</p>
                  </div>
                </div>
                <div class="semiStep semiStep_5" [ngClass]="{'active' : currentPM === 'apmgw_MoneyBookers', 'withBonus': bonusDetails}">
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_MoneyBookers'}">
                    <label for="registration_MoneyBookersId">Player Email</label>
                    <input autocomplete="nope" id="registration_MoneyBookersId" type="text" placeholder="Player Email" formControlName="MoneyBookersId" class="inputClass"
                           (keyup)="validatePmsForOnly3Step(); varInvalid['MoneyBookersId'] = invalidMoneyBookersId();"
                           [ngClass]="{
                                            'error': varInvalid['MoneyBookersId'],
                                            'success': MoneyBookersId.valid && (MoneyBookersId.dirty || MoneyBookersId.touched) && MoneyBookersId.value.length > 0
                                       }" />
                  </div>
                </div>
                <div class="semiStep semiStep_6" [ngClass]="{'active' : currentPM === 'apmgw_Trustly_DI', 'withBonus': bonusDetails}">
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Trustly_DI'}">
                    <h2>{{ 'freshRegistration.apm.global.title' | translate | replace:'\\[pm-name\\]':currentPMname }}</h2>
                  </div>
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Trustly_DI'}">
                    <p>{{ 'freshRegistration.apm.global.message' | translate | replace:'\\[pm-name\\]':currentPMname }}</p>
                  </div>
                </div>
                <div class="semiStep semiStep_7" [ngClass]="{'active' : currentPM === 'apmgw_Pugglepay', 'withBonus': bonusDetails}">
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Pugglepay'}">
                    <h2>{{ 'freshRegistration.apm.global.title' | translate | replace:'\\[pm-name\\]':currentPMname }}</h2>
                  </div>
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Pugglepay'}">
                    <p>{{ 'freshRegistration.apm.global.message' | translate | replace:'\\[pm-name\\]':currentPMname }}</p>
                  </div>
                </div>
                <div class="semiStep semiStep_8" [ngClass]="{'active' : currentPM === 'apmgw_Giropay', 'withBonus': bonusDetails}">
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Giropay'}">
                    <h2>{{ 'freshRegistration.apm.global.title' | translate | replace:'\\[pm-name\\]':currentPMname }}</h2>
                  </div>
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Giropay'}">
                    <p>{{ 'freshRegistration.apm.global.message' | translate | replace:'\\[pm-name\\]':currentPMname }}</p>
                  </div>
                </div>
                <div class="semiStep semiStep_9" [ngClass]="{'active' : currentPM === 'apmgw_Interac', 'withBonus': bonusDetails}">
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Interac'}">
                    <h2>{{ 'freshRegistration.apm.global.title' | translate | replace:'\\[pm-name\\]':currentPMname }}</h2>
                  </div>
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Interac'}">
                    <p>{{ 'freshRegistration.apm.global.message' | translate | replace:'\\[pm-name\\]':currentPMname }}</p>
                    <span class="trademark trademark_{{languagePage}}">{{ 'freshRegistration.apm.interac.trademark' | translate }}</span>
                  </div>
                </div>
                <div class="semiStep semiStep_10" [ngClass]="{'active' : currentPM === 'apmgw_ecoPayz', 'withBonus': bonusDetails}">
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_ecoPayz'}">
                    <h2>{{ 'freshRegistration.apm.global.title' | translate | replace:'\\[pm-name\\]':currentPMname }}</h2>
                  </div>
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_ecoPayz'}">
                    <p>{{ 'freshRegistration.apm.global.message' | translate | replace:'\\[pm-name\\]':currentPMname }}</p>
                  </div>
                </div>
                <div class="semiStep semiStep_11" [ngClass]="{'active' : currentPM === 'apmgw_Interac_eTransfer', 'withBonus': bonusDetails}">
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Interac_eTransfer'}">
                    <h2>{{ 'freshRegistration.apm.global.title' | translate | replace:'\\[pm-name\\]':currentPMname }}</h2>
                  </div>
                  <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Interac_eTransfer'}">
                    <p>{{ 'freshRegistration.apm.global.message' | translate | replace:'\\[pm-name\\]':currentPMname }}</p>
                    <span class="trademark trademark_{{languagePage}}">{{ 'freshRegistration.apm.interac.trademark' | translate }}</span>
                  </div>
                </div>
                <div class="semiStep semiStep_11" [ngClass]="{'active' : currentPM === 'apmgw_Fast_Bank_Transfer', 'withBonus': bonusDetails}">
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Fast_Bank_Transfer'}">
                    <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Fast_Bank_Transfer'}">
                      <label for="registration_Payee">Payee</label>
                      <input autocomplete="nope" id="registration_Payee" type="text" placeholder="Payee" formControlName="Payee"
                             (keyup)="validatePmsForOnly3Step(); varInvalid['Payee'] = invalidPayee();"
                             class="inputClass"
                             [ngClass]="{
                                                'error': varInvalid['Payee'],
                                                'success': Payee.valid && (Payee.dirty || Payee.touched) && Payee.value.length > 0
                                           }" />
                    </div>
                  </div>
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Fast_Bank_Transfer'}">
                    <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Fast_Bank_Transfer'}">
                      <label for="registration_IBAN">IBAN</label>
                      <input autocomplete="nope" id="registration_IBAN" type="text" placeholder="IBAN" formControlName="IBAN"
                             (keyup)="validatePmsForOnly3Step(); varInvalid['IBAN'] = invalidIBAN();"
                             class="inputClass"
                             [ngClass]="{
                                                'error': varInvalid['IBAN'],
                                                'success': IBAN.valid && (IBAN.dirty || IBAN.touched) && IBAN.value.length > 0
                                           }" />
                    </div>
                  </div>
                  <div class="form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Fast_Bank_Transfer'}">
                    <div class="semi-form-group" [ngClass]="{'disabled' : currentPM != 'apmgw_Fast_Bank_Transfer'}">
                      <label for="registration_Swift">Swift</label>
                      <input autocomplete="nope" id="registration_Swift" type="text" placeholder="Swift" formControlName="Swift"
                             (keyup)="validatePmsForOnly3Step(); varInvalid['Swift'] = invalidSwift();"
                             class="inputClass"
                             [ngClass]="{
                                                'error': varInvalid['Swift'],
                                                'success': Swift.valid && (Swift.dirty || Swift.touched) && Swift.value.length > 0
                                           }" />
                    </div>
                  </div>

                </div>
                <div class="confirmation" [ngClass]="{'active' : confStat !== 'start', 'finished' : confStat === 'success', 'withBonus': bonusDetails}">
                  <div class="icon {{confStat}}"  [ngClass]="{'active' : confStat !== 'start'}"></div>
                  <div [ngClass]="{'active' : confStat === 'error'}">
                    <span>{{currentError}}</span>
                  </div>
                  <div [ngClass]="{'active' : confStat === 'success'}">
                    <h2> {{realNamePM}} {{ 'freshRegistration.methodAdded' | translate }}</h2>
                    <span class="info">{{ 'freshRegistration.succesfullyAdded' | translate }}</span>
                  </div>
                  <div [ngClass]="{'active' : confStat === 'waiting'}">{{ 'freshRegistration.processingYourCard' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="jinniErrorBubble"><app-jinni-errors-messages [close]="close"></app-jinni-errors-messages></div>
          </div>
          <div class="tacParent currentStep_{{step}}">
            <input autocomplete="nope" type="checkbox" name="termsAndConditions" id="registration_termsAndConditions" formControlName="terms" (change)="varInvalid['Terms'] = invalidTerms();" />
            <label for="registration_termsAndConditions" class="termsAndConditions currentStep_{{step}}"
                   [ngClass]="{
                            'error': varInvalid['Terms'],
                            'success': terms.value
                       }">{{ 'modals.newRegisterText' | translate }}
              <a *ngIf="!IOS_native" target="_blank" [routerLink]="[languagePage, 'terms-conditions']"> {{ 'modals.tac' | translate }}</a>
              <a *ngIf="IOS_native"  (click)="browserNavigate($event, 'terms-conditions' )"> {{ 'modals.tac' | translate }}</a>
              {{ 'modals.newRegisterText2' | translate }}
              <a *ngIf="!IOS_native" target="_blank" [routerLink]="[languagePage, 'privacy-policy']">{{ 'modals.pp' | translate }}</a>
              <a *ngIf="IOS_native"  (click)="browserNavigate($event, 'privacy-policy' )"> {{ 'modals.pp' | translate }}</a>

              {{ 'modals.newRegisterText3' | translate }}
            </label>
          </div>
          <span *ngIf="step == 1 && lotteryService.isMobile" class="maybeLogin">{{ 'modals.already2' | translate }} <span (click)="showLogin()">{{ 'login.lbtn2' | translate }}.</span></span>
          <button class="przycisk green big continueButton" type="{{buttonType}}" (click)="nextStep();"
                  [ngClass]="{
                                        'active': (step === 1 && password.valid && email.valid && emailIsAvalible && mobile.valid && prefix.valid) ||
                                        (step === 2 && step_1_validated && terms.value && postcode.valid && city.valid && address.valid && lastName.valid && firstName.valid && birthDay.valid && birthMonth.valid && birthYear.valid && birthDateIsValid && gender.valid) ||
                                        (step === 3 && step_1_validated && step_2_validated && step_3_validated) ||
                                        (step === 3 && step_1_validated && step_2_validated && step_3_validated) ||
                                        (step === 3 && step_3_validated && showOnlyPM),
                                        'disabled-btn' : isLoadingButton || goTo === 'tryAgain' || holdButtonDisabled
                                   }">
                        <span *ngIf="buttonType !== 'submit' && (step === 1 || step === 2)">
                            <span *ngIf="goTo !== 'tryAgain'">{{ 'freshRegistration.continue' | translate }}</span>
                            <span *ngIf="goTo === 'tryAgain'">{{ 'freshRegistration.tryAgain' | translate }}</span>
                        </span>
            <span *ngIf="buttonType === 'submit' && step === 1">
                            <span>{{ 'freshRegistration.continue' | translate }}</span>
                        </span>
            <span *ngIf="buttonType === 'submit' && step === 2">
                            <span>{{ 'freshRegistration.completeRegistration' | translate }}</span>
                        </span>
            <span *ngIf="step === 3 && confStat !== 'success' && confStat !== 'error'">
                            <span *ngIf="currentPM === 'Card'">{{ 'dashboard.addFunds.addPaymentMethod' | translate }}</span>
                            <span *ngIf="currentPM !== 'Card'">{{ 'freshRegistration.apm.global.button' | translate | replace:'\\[pm-name\\]':currentPMname }}</span>
                        </span>
            <span *ngIf="step === 3 && confStat === 'success'">
                            <span>{{ 'freshRegistration.continue' | translate }}</span>
                        </span>
            <span *ngIf="step === 3 && confStat === 'error'">
                            <span>{{ 'freshRegistration.tryAgain' | translate }}</span>
                        </span>
            <span *ngIf="isLoadingButton" class="spinner"></span>
          </button>
        </form>
        <span *ngIf="step == 1 && !lotteryService.isMobile" class="maybeLogin">{{ 'modals.already2' | translate }} <span (click)="showLogin()">{{ 'login.lbtn2' | translate }}.</span></span>
      </div>
    </div>
  </div>
</div>
